module.exports = __webpack_public_path__ + "img/BAU Seniors_32.3086447c.jpg";